import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type { Account, AccountVariables } from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<AccountVariables, null>) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid, aid } = descriptor;

  const search = {
    uid,
    cid,
    accountId: aid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Account/CreateExpertFromSmart${searchString}`;
}

function ccOptionsFactory() {
  const defaultOptions = getDefaultOptions();
  return {
    ...defaultOptions,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  };
}

export const fetchRequestContract = createRequestContract<AccountVariables, null>({
  schema,
  dataPath: 'user:customer:account:create_expert_from_smart',
  verb: requestVerbs.POST,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  parentKeySelector: variables => variables.locator.descriptor.aid,
});

export const fetchResponseContract = createResponseContract<
  AccountVariables,
  null,
  Account,
  Account,
  Account
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,

  keySelector: entity => entity.id,
  processorFn: response => response,
});
